/* import __COLOCATED_TEMPLATE__ from './fin-banner.hbs'; */
/* RESPONSIBLE TEAM: team-self-serve */

import { action } from '@ember/object';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { inject as service } from '@ember/service';
import type RouterService from '@ember/routing/router-service';
import type AiAgentSetupService from 'embercom/services/ai-agent-setup-service';
const BANNER_HIDDEN_KEY = 'email_domains_and_addresses_banner_hidden_until';

export default class EmailDomainsAndAddressesFinBanner extends Component {
  @service intercomEventService: any;
  @service declare router: RouterService;
  @service declare aiAgentSetupService: AiAgentSetupService;

  @tracked isBannerHidden = false;

  constructor(owner: unknown, args: {}) {
    super(owner, args);
    this.checkBannerHiddenState();
  }

  @action
  private checkBannerHiddenState(): void {
    let hiddenUntil = localStorage.getItem(BANNER_HIDDEN_KEY);
    if (hiddenUntil) {
      let hiddenUntilDate = new Date(hiddenUntil);
      this.isBannerHidden = hiddenUntilDate > new Date();
    }
  }

  @action
  hideBanner(): void {
    let oneMonthFromNow = new Date();
    oneMonthFromNow.setMonth(oneMonthFromNow.getMonth() + 1);
    localStorage.setItem(BANNER_HIDDEN_KEY, oneMonthFromNow.toISOString());
    this.isBannerHidden = true;
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'fin_ai_banner_hide_button',
      place: 'settings_channels_email',
      section: 'domains_and_addresses_fin_ai_banner',
    });
  }

  @action
  onBannerCtaClick(): void {
    this.intercomEventService.trackAnalyticsEvent({
      action: 'clicked',
      object: 'fin_ai_banner_cta_link',
      place: 'settings_channels_email',
      section: 'domains_and_addresses_fin_ai_banner',
    });
    this.router.transitionTo('apps.app.automation.fin-ai-agent.deploy.email');
  }

  get finEmailIsLive(): boolean {
    return (
      this.aiAgentSetupService.isFinSetupEmailRulesetLive ||
      this.aiAgentSetupService.isFinLiveInChannelOutsideSetup('email')
    );
  }

  get showBanner(): boolean {
    return (
      !this.isBannerHidden &&
      this.aiAgentSetupService.validateEmailSetup.isValid &&
      !this.finEmailIsLive
    );
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Channels::Email::DomainsAndAddresses::FinBanner': typeof EmailDomainsAndAddressesFinBanner;
    'new-settings/channels/email/domains-and-addresses/fin-banner': typeof EmailDomainsAndAddressesFinBanner;
  }
}
